export default function ($scope, $timeout, $mdDialog, Restangular, FlashService) {

    let type = $scope.$parent.type;
    let states = $scope.$parent.states;
    let user = $scope.$parent.user;
    let purchase = $scope.$parent.purchase;
    let subscriptions = $scope.$parent.subscriptions;
    let games = $scope.$parent.games;
    let active_licences = $scope.$parent.active_licences;

    $scope.iban = $scope.$parent.iban;
    $scope.licence = {};
    $scope.states = states;
    $scope.invoice_data = 'user';
    $scope.validateCodeTime = null;

    $scope.subscriptions = {};
    $scope.games = {};
    $scope.active_types = [];


    active_licences.forEach(function(v, i){
        $scope.active_types[v.type.id] = v.type.id;
    });

    subscriptions.forEach(function(v, i){

        if(!v.licencesType){
            $scope.subscriptions[v.id] = v;
        }else{
            v.licencesType.forEach(function(s, i){
                if($scope.active_types.indexOf(s) >= 0){
                    $scope.subscriptions[v.id] = v;
                }
            });
        }
    });

    games.forEach(function(v, i){
        $scope.games[v.id] = v;
    });

    $scope.pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    if(purchase){

        $scope.product = purchase.product.id;

        if(purchase.product.type == 'subscription'){
            $scope.subscriptions[$scope.product].promotional = false;

            if(purchase.method == "wire"){
                $scope.method = "wire";
                $scope.isBuy = true;

                let date = ParseDate(purchase.created);
                $scope.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(purchase.id, 4);
            }
        }

        if(purchase.product.type == 'game'){
            $scope.games[$scope.product].promotional = false;

            if(purchase.method == "wire"){
                $scope.method = "wire";
                $scope.isBuy = true;

                let date = ParseDate(purchase.created);
                $scope.order = date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + $scope.pad(purchase.id, 4);
            }
        }

        if(purchase.invoice_data.invoice_data == "other"){
            $scope.invoice_data = purchase.invoice_data.invoice_data;
            $scope.company = purchase.invoice_data.company;
            $scope.name = purchase.invoice_data.name;
            $scope.surname = purchase.invoice_data.surname;
            $scope.city = purchase.invoice_data.city;
            $scope.address = purchase.invoice_data.address;
            $scope.postalCode = purchase.invoice_data.postalCode;
            $scope.state = purchase.invoice_data.state;
            $scope.cif = purchase.invoice_data.cif
        }
    }

    if(HasRole('company')){
        $scope.data = user.name+ " - "+ user.cif;
    }
    if(HasRole('prenscriptor')){
        $scope.data = user.name+ " "+user.surname+" - "+ user.cif;
    }

    $scope.$watch('product', function(new_value, old_value){
        let tax = 21;
        let price = 0;

        if(user.state && user.state.country && user.state.country.tax)
            tax = user.state.country.tax;

        if($scope.subscriptions[new_value])
            price = $scope.subscriptions[new_value].price;

        if($scope.games[new_value])
            price = $scope.games[new_value].price;

        $scope.tax = tax;
        $scope.total =  price / (tax / 100 + 1);
        $scope.taxes =  price - $scope.total;
        $scope.total_taxes = price;

        $scope.form.promotion.$setValidity('no', true);
    });

    $scope.validateCodeChange = function(){
        $scope.form.promotion.$setValidity('no', true);

        if($scope.validateCodeTime != null){
            $timeout.cancel($scope.validateCodeTime);
        }

        $scope.validateCodeTime = $timeout(function(){
            $scope.validateCode();
        }, 2000);
    }

    $scope.validateCodeEnter = function ($event) {
        $scope.form.promotion.$setValidity('no', true);

        if($scope.validateCodeTime != null)
            $timeout.cancel($scope.validateCodeTime);

        $scope.validateCodeTime = $timeout(function(){
            $scope.validateCode();
        }, 2000);
    };

    $scope.validateCode = function () {
        if(!$scope.promotion)
            return $scope.form.promotion.$setValidity('no', true);


        Restangular
            .one('promotional_code/validate/'+$scope.promotion)
            .get()
            .then(data => {
                data = data.data ? data.data : data;

                if(data.product){
                    data.product.promotional = false;

                    if(data.product.type == 'subscription')
                        $scope.subscriptions[data.product.id] = data.product;

                    if(data.product.type == 'game')
                        $scope.games[data.product.id] = data.product;

                    $scope.product = data.product.id;
                }

                $scope.form.promotion.$$element.blur()

            }, error => {
                $scope.form.promotion.$setValidity('no', false);

                $scope.form.promotion.$$element.blur().focus()
            });
    };

    $scope.buy = function(ev){

        $scope.dataLoading = true;

        let data = {
            product : $scope.product,
            invoice_data : $scope.invoice_data,
            method : $scope.method,
            company : $scope.company,
            name : $scope.name,
            surname : $scope.surname,
            city: $scope.city,
            address: $scope.address,
            postalCode: $scope.postalCode,
            state: $scope.state,
            cif: $scope.cif
        };

        if(purchase && purchase.id)
            data.purchase = purchase.id;

        if($scope.method == 'credit_card'){

            Restangular
                .all('purchase/creditcard')
                .post(data)
                .then(data => {
                    $scope.isBuy = true;
                    $scope.dataLoading = false;

                    data = data.data ? data.data : data;

                    $('#params').val(data.params);
                    $('#signature').val(data.signature);

                    $('#visa').attr('action', data.url)
                        .submit();
                });
        }else if($scope.method == 'wire'){
            Restangular
                .all('purchase/wire')
                .post(data)
                .then(data => {
                    data = data.data ? data.data : data;

                    $scope.isBuy = true;
                    $scope.dataLoading = false;
                    $scope.order = data.order;

                    var translate = $scope.$parent.translate;

                    var alert = $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .htmlContent ('<h3>'+translate('BUY_SUCCESS')+'</h3>' + "<br>" + translate('YOU_MUST_MAKE_BANK_TRANSFER') + " <strong>" + $scope.iban + "</strong> "+ '<br>' + translate('WITH_THE_CONCEPT') + ': <strong>' + translate('ORDER') + ' '+ data.order + '</strong>')
                            .targetEvent(ev)
                            .fullscreen(true)
                            .ok("ok")
                        ;

                    $mdDialog.show(alert);

                });

        }else if($scope.method == 'paypal'){


        }
    };
}


/** WEBPACK FOOTER **
 ** ./js/theme/purchases/block/controller.js
 **/